<div class="geometrypad-editor flex flex-col overflow-y-auto p-4">
  <dojo-geo-element-list-section
    [params]="params()"
    [display]="display()"
    [coordSystem]="coordSystem()"
    [geometryDisplay]="geometryDisplay()"
    [behaviorControls]="behaviorControls()"
    [interactivePorts]="interactivePorts()"
    [reactions]="reactions()"
    (paramsChange)="onParamsChange($event)"
    (displayChange)="onDisplayChange($event)"
    (coordSystemChange)="onCoordSystemChange($event)"
    (behaviorControlsChange)="onBehaviorControlsChange($event)"
    (interactivePortsChange)="onInteractivePortsChange($event)"
    (reactionsChange)="onReactionsChange($event)"
  />
</div>
